import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "Progreso de la educación",
  "lead": "La educación ilumina cada etapa del camino hacia una vida mejor. Todos los niños necesitan tener acceso a una educación de buena calidad para desarrollar su potencial de aprendizaje y aprovechar los beneficios generales de la educación. Es necesario esforzarse principalmente para que todos los niños y jóvenes puedan beneficiarse de manera equitativa de su poder transformador. Esto requiere recursos suficientes, en especial para llegar a quienes necesitan más apoyo."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, PageLink, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scope",
        children: "SCOPE"
      }), _jsxs(_components.p, {
        children: ["La educación ilumina cada etapa del camino hacia una vida mejor. Todos los niños necesitan tener ", _jsx(HighlightByTheme, {
          theme: "access",
          children: "acceso"
        }), " a una educación de buena ", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "calidad"
        }), " para desarrollar su potencial de ", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "aprendizaje"
        }), " y aprovechar los beneficios generales de la educación. Es necesario esforzarse principalmente para que todos los niños y jóvenes puedan beneficiarse de manera ", _jsx(HighlightByTheme, {
          theme: "equity",
          children: "equitativa"
        }), " de su poder transformador. Esto requiere", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "recursos"
        }), " suficientes, en especial para llegar a quienes necesitan más apoyo."]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["En 2015, la comunidad internacional incluyó un objetivo sobre educación, ", _jsx(_components.a, {
          href: "https://sustainabledevelopment.un.org/sdg4",
          children: "ODS 4"
        }), ", entre los 17 Objetivos de Desarrollo Sostenible que deberían alcanzarse antes de 2030. Desde entonces, se estableció un ", _jsx(PageLink, {
          name: "indicadores",
          children: "marco detallado"
        }), " para efectuar un seguimiento del progreso hacia la consecución de las metas del Objetivo. En este sitio, SCOPE, se resumen los datos y tendencias clave de la educación en todo el mundo basándose en cinco temas:"]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["El sitio complementa la información que se proporciona en la versión impresa del ", _jsx(_components.a, {
          href: "https://es.unesco.org/gem-report/allreports",
          children: "Informe de Seguimiento de la Educación en el Mundo"
        }), ", una herramienta que permite a la comunidad internacional realizar un seguimiento y un examen de los progresos alcanzados en favor de nuestro objetivo sobre educación, el ODS 4."]
      })
    }), "\n", _jsx(LandingButton, {
      children: "Empiece a leer"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
